import {clsx} from 'clsx'
import {twMerge} from 'tailwind-merge'

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export const isNotEmptyAndDefined = value => {
  return value !== undefined && value !== ''
}
export const isObjectNotEmpty = obj => {
  return Object.keys(obj).every(key => obj[key] !== null && obj[key] !== undefined && obj[key] !== '')
}
export const downloadCSVFiles = (csvString, fileName = 'File.csv') => {
  const blob = new Blob([csvString], {type: 'text/csv;charset=utf-8;'})

  const link = document.createElement('a')

  link.download = fileName

  link.href = URL.createObjectURL(blob)

  link.click()

  URL.revokeObjectURL(link.href)
}
export const getDateWithTimeString = () => {
  const date = new Date()
  const isoString = date.toISOString()
  const formattedDate = isoString
    .replace('T', '_')
    .replace(/\.\d{3}Z/, '')
    .replaceAll(':', '')
  return formattedDate
}

export const chooseByCondition = (condition,ifTrue,ifFalse) => {
  return condition ? ifTrue : ifFalse
}

export const convertImageToWebP = async (file, options = {}) => {
  const {quality = 0.9, entityType = null} = options
  const fileName = file?.name?.replace(/\.(png|jpe?g)$/i, '')

  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = event => {
      const img = new Image()
      img.onload = () => {
        const canvas = document.createElement('canvas')
        canvas.width = img.width
        canvas.height = img.height
        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0)

        canvas.toBlob(
          blob => {
            if (blob) {
              const webpFile = new File([blob], file?.type === 'image/webp' ? fileName : `${fileName}.webp`, {
                type: 'image/webp',
              })
              webpFile.error = file?.error ?? false

              resolve({
                webpFile,
                metadata: {
                  originalFileName: file?.name,
                  id: file?.type === 'image/webp' ? fileName?.split('.')[0] : fileName,
                  blobFormat: 'webp',
                  width: img.width,
                  height: img.height,
                  originalFormat: file?.type,
                  originalSize: file?.size,
                  blobFileSize: webpFile.size,
                  referenceEntity: entityType,
                },
                file: file,
              })
            } else {
              reject(new Error('Conversion to WebP failed'))
            }
          },
          'image/webp',
          quality
        )
      }
      img.onerror = () => reject(new Error('Image load failed'))
      img.src = event.target.result
    }
    reader.onerror = () => reject(new Error('File reading failed'))
    reader.readAsDataURL(file)
  })
}
